import { render, staticRenderFns } from "./CardInput.vue?vue&type=template&id=22637057&scoped=true&"
import script from "./CardInput.vue?vue&type=script&lang=js&"
export * from "./CardInput.vue?vue&type=script&lang=js&"
import style0 from "./CardInput.vue?vue&type=style&index=0&id=22637057&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22637057",
  null
  
)

export default component.exports